module.exports = __webpack_public_path__ + "img/logo-dark.8566b5f1.png";